"use strict";

var _react = _interopRequireDefault(require("react"));
require("./promise-polyfill");
require("core-js/stable");
require("regenerator-runtime/runtime");
var _thenRequest = _interopRequireDefault(require("then-request"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _client = _interopRequireWildcard(require("bicycle/client"));
var _reactRouterDom = require("react-router-dom");
var _reactBicycle = require("react-bicycle");
var _reactGateway = require("react-gateway");
var _LoginContext = require("./login/LoginContext");
var _client2 = _interopRequireDefault(require("./login/client"));
var _app = _interopRequireDefault(require("./components/app"));
var _captureClientBreadcrumb = _interopRequireDefault(require("./capture-client-breadcrumb"));
var _StripeElements = _interopRequireDefault(require("./components/core/StripeElements"));
var _validationContext = require("./components/core/validation-context");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* global CSRF_TOKEN, SERVER_PREPARATION, LOGIN_STATE, ga */

const networkLayer = new _client.NetworkLayer('/bicycle', {
  headers: {
    'x-csrf-token': CSRF_TOKEN
  }
});
const client = new _client.default({
  networkLayer: {
    send(message) {
      (0, _captureClientBreadcrumb.default)({
        message: 'Make bicycle request ',
        category: 'bicycle',
        data: {
          sessionID: message.s || '',
          queryUpdate: JSON.stringify(message.q),
          mutations: message.m ? JSON.stringify(message.m) : ''
        },
        level: 'debug'
      });
      return networkLayer.send(message);
    }
  },
  serverPreparation: SERVER_PREPARATION,
  // keep fetched queries locally for up to 1 minutes
  cacheTimeout: 60 * 1000
});
/*
// TODO: capture both these errors and send them to raven with as much context as possible
client.subscribeToNetworkErrors(err => {

});
client.subscribeToMutationErrors(err => {

});
*/
const originalUpdate = client.update;
client.update = (method, args, optimisticUpdate) => {
  const data = {};
  if (args) {
    Object.keys(args).forEach(key => {
      data[key] = '' + args[key];
    });
  }
  (0, _captureClientBreadcrumb.default)({
    message: 'Run muation ' + method,
    category: 'bicycle',
    data,
    level: 'info'
  });
  return originalUpdate.call(client, method, args, optimisticUpdate);
};
window.CLIENT = client;

// ********************************************************************************************
// ******************************** OPTIMISTIC UPDATERS ***************************************
// ********************************************************************************************

function optimisticSort(root, cacheObject, fieldName, type, ids) {
  const oldItems = cacheObject.get(fieldName);
  cacheObject.set(fieldName, ids.map(id => root.getObject(type, id)).concat((oldItems || []).filter(c => ids.indexOf(c.get('id')) === -1)));
}
client.defineOptimisticUpdaters({
  AgeCategory: {
    set({
      args: {
        id,
        field,
        value
      }
    }, cache) {
      cache.getObject('AgeCategory', id).set(field, value);
    },
    sort({
      args: {
        ageCategoryIDs
      }
    }, cache) {
      optimisticSort(cache, cache, 'ageCategories', 'AgeCategory', ageCategoryIDs);
    }
  },
  Basket: {
    dismissCheckoutError(mutation, cache) {
      if (LOGIN_STATE && LOGIN_STATE.user && LOGIN_STATE.user.id) {
        cache.getObject('Basket', LOGIN_STATE.user.id).set('checkoutError', null);
      }
    }
  },
  Calendar: {
    set({
      args: {
        id,
        field,
        value
      }
    }, cache) {
      cache.getObject('Calendar', id).set(field, value);
    }
  },
  CalendarDate: {
    set({
      args: {
        id,
        field,
        value
      }
    }, cache) {
      cache.getObject('CalendarDate', id).set(field, value);
    }
  },
  Application: {
    set({
      args: {
        id,
        field,
        value
      }
    }, cache) {
      cache.getObject('Application', id).set(field, value);
    }
  },
  ApplicationTier: {
    set({
      args: {
        id,
        field,
        value
      }
    }, cache) {
      cache.getObject('Application', id).set(field, value);
    }
  },
  CalendarSpecial: {
    set({
      args: {
        id,
        field,
        value
      }
    }, cache) {
      cache.getObject('CalendarSpecial', id).set(field, value);
    }
  },
  ClassDivision: {
    set({
      args: {
        id,
        field,
        value
      }
    }, cache) {
      if (field === 'isRanking' && !value) {
        cache.getObject('ClassDivision', id).set('isRanking', false).set('bibMain', null).set('bibText', null).set('bibTextBackground', null);
      } else {
        cache.getObject('ClassDivision', id).set(field, value);
      }
    },
    sort({
      args: {
        classDivisionIDs
      }
    }, cache) {
      optimisticSort(cache, cache, 'classDivisions', 'ClassDivision', classDivisionIDs);
    }
  },
  Club: {
    sendInstructionsToTreasurer({
      args: {
        clubID
      }
    }, cache) {
      return {
        ['Club:' + clubID]: {
          treasurerEmailSent: new Date(Date.now() + 100000).toISOString()
        }
      };
    }
  },
  CodeType: {
    sort({
      args: {
        codeType,
        refCodeIDs
      }
    }, cache) {
      optimisticSort(cache, cache.getObject('CodeType', codeType), 'refCodes', 'RefCode', refCodeIDs);
    }
  },
  Competition: {
    set({
      args: {
        id,
        field,
        value
      }
    }, cache) {
      cache.getObject('Competition', id).set(field, value);
    }
  },
  CompetitionAdministrator: {
    set({
      args: {
        id,
        field,
        value
      }
    }, cache) {
      cache.getObject('CompetitionAdministrator', id).set(field, value);
    }
  },
  CompetitionDay: {
    set({
      args: {
        id,
        field,
        value
      }
    }, cache) {
      cache.getObject('CompetitionDay', id).set(field, value);
    },
    sortStartList({
      args: {
        dayID,
        startListRunIDs
      }
    }, cache) {
      optimisticSort(cache, cache.getObject('CompetitionDay', dayID), 'startListRuns', 'StartListRun', startListRunIDs);
    }
  },
  CompetitionDivision: {
    set({
      args: {
        id,
        field,
        value
      }
    }, cache) {
      cache.getObject('CompetitionDivision', id).set(field, value);
    }
  },
  County: {
    set({
      args: {
        id,
        field,
        value
      }
    }, cache) {
      cache.getObject('County', id).set(field, value);
    }
  },
  DayRaceOrder: {
    set({
      args: {
        id,
        field,
        value
      }
    }, cache) {
      cache.getObject('DayRaceOrder', id).set(field, value);
    }
  },
  DefaultRun: {
    set({
      args: {
        id,
        field,
        value
      }
    }, cache) {
      cache.getObject('DefaultRun', id).set(field, value);
    },
    sort({
      args: {
        defaultRunIDs
      }
    }, cache) {
      optimisticSort(cache, cache, 'defaultRuns', 'DefaultRun', defaultRunIDs);
    }
  },
  DefaultRace: {
    set({
      args: {
        id,
        field,
        value
      }
    }, cache) {
      cache.getObject('DefaultRace', id).set(field, value);
    }
  },
  Entry: {
    set({
      args: {
        id,
        field,
        value
      }
    }, cache) {
      if (field === 'entrySortDate') {
        cache.getObject('Entry', id).set('effectiveEntryDate', value);
      } else {
        cache.getObject('Entry', id).set(field, value);
      }
    },
    removeRTC({
      args: {
        entryID,
        rtcRef
      }
    }, cache) {
      const entry = cache.getObject('Entry', entryID);
      const rtcRefs = entry.get('rtcRefs');
      if (rtcRefs) {
        entry.set('rtcRefs', rtcRefs.filter(ref => ref !== rtcRef));
      }
    },
    createRTC({
      args: {
        entryID,
        rtcRef
      }
    }, cache) {
      const entry = cache.getObject('Entry', entryID);
      entry.set('rtcRefs', [...(entry.get('rtcRefs') || []), rtcRef]);
    }
  },
  EntryFee: {
    set({
      args: {
        id,
        field,
        value
      }
    }, cache) {
      cache.getObject('EntryFee', id).set(field, value);
    }
  },
  EntryType: {
    set({
      args: {
        id,
        field,
        value
      }
    }, cache) {
      cache.getObject('EntryType', id).set(field, value);
    },
    sort({
      args: {
        entryTypeIDs
      }
    }, cache) {
      optimisticSort(cache, cache, 'entryTypes', 'EntryType', entryTypeIDs);
    }
  },
  EntryTypeOverride: {
    set({
      args: {
        id,
        field,
        value
      }
    }, cache) {
      cache.getObject('EntryTypeOverride', id).set(field, value);
    }
  },
  QueryResponse: {
    upsert: ({
      args: {
        entryID,
        specialRef,
        response
      }
    }, cache) => {
      const qr = cache.getObject('queryResponses', entryID + '*' + specialRef);
      if (qr) qr.set('response', response);
    }
  },
  Race: {
    set({
      args: {
        id,
        field,
        value
      }
    }, cache) {
      cache.getObject('Race', id).set(field, value);
    }
  },
  RefCode: {
    set({
      args: {
        id,
        field,
        value
      }
    }, cache) {
      cache.getObject('RefCode', id).set(field, value);
    }
  },
  Site: {
    set({
      args: {
        id,
        field,
        value
      }
    }, cache) {
      cache.getObject('Site', id).set(field, value);
    }
  },
  StartListRun: {
    set({
      args: {
        id,
        field,
        value
      }
    }, cache) {
      cache.getObject('StartListRun', id).set(field, value);
    }
  },
  DefaultTier: {
    set({
      args: {
        id,
        field,
        value
      }
    }, cache) {
      cache.getObject('DefaultTier', id).set(field, value);
    }
  },
  DefaultTierFeeAdjustment: {
    set({
      args: {
        id,
        field,
        value
      }
    }, cache) {
      cache.getObject('DefaultTier', id).set(field, value);
    }
  }
});

// ********************************************************************************************

const loginClient = (0, _client2.default)(LOGIN_STATE, (method, path, options = {}) => {
  return (0, _thenRequest.default)(method, path, {
    ...options,
    headers: {
      ...options.headers,
      ['x-csrf-token']: CSRF_TOKEN
    }
  });
});
const BEFORE = document.getElementById('container').innerHTML;
_reactDom.default.render( /*#__PURE__*/_react.default.createElement(_validationContext.ValidationContextProvider, null, /*#__PURE__*/_react.default.createElement(_StripeElements.default, null, /*#__PURE__*/_react.default.createElement(_reactBicycle.Provider, {
  client: client
}, /*#__PURE__*/_react.default.createElement(_LoginContext.LoginProvider, {
  client: loginClient
}, /*#__PURE__*/_react.default.createElement(_reactGateway.GatewayProvider, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
  id: "application"
}, /*#__PURE__*/_react.default.createElement(_reactRouterDom.BrowserRouter, null, /*#__PURE__*/_react.default.createElement(_app.default, null))), /*#__PURE__*/_react.default.createElement(_reactGateway.GatewayDest, {
  name: "top-level"
}))))))), document.getElementById('container'));
/*
const AFTER = document.getElementById('container').innerHTML;
if (BEFORE !== AFTER) {
  console.log('before');
  console.log(BEFORE);
  console.log('after');
  console.log(AFTER);
}
*/

// google analytics tracking code
/* eslint-disable */
(function (i, s, o, g, r, a, m) {
  i['GoogleAnalyticsObject'] = r;
  i[r] = i[r] || function () {
    (i[r].q = i[r].q || []).push(arguments);
  }, i[r].l = 1 * new Date();
  a = s.createElement(o), m = s.getElementsByTagName(o)[0];
  a.async = 1;
  a.src = g;
  m.parentNode.insertBefore(a, m);
})(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
ga('create', 'UA-31798041-6', 'auto');
ga('send', 'pageview');
/* eslint-enable */